import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../components/Footer';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft, FiPieChart } = FiIcons;

const Cookies = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-[#004d44]">
      <nav className="fixed top-0 w-full z-50 bg-white/90 backdrop-blur-md shadow-sm py-4">
        <div className="max-w-7xl mx-auto px-4 flex justify-between items-center">
          <a href="/" className="flex items-center gap-2 group">
            <div className="w-8 h-8 rounded-lg bg-[#00a48c] text-white flex items-center justify-center font-black">S</div>
            <span className="text-xl font-black tracking-tight">Simulation Rendement PER</span>
          </a>
          <a href="/" className="flex items-center gap-2 text-sm font-bold text-[#00a48c] hover:underline">
            <SafeIcon icon={FiArrowLeft} /> Retour à l'accueil
          </a>
        </div>
      </nav>

      <main className="pt-32 pb-20 px-4">
        <div className="max-w-4xl mx-auto">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 rounded-2xl bg-[#f0fcf9] text-[#00a48c] flex items-center justify-center text-2xl">
                <SafeIcon icon={FiPieChart} />
              </div>
              <h1 className="text-4xl font-black uppercase tracking-tight">Gestion des Cookies</h1>
            </div>

            <div className="prose prose-slate max-w-none space-y-8 text-gray-600 font-medium leading-relaxed">
              <section>
                <h2 className="text-xl font-black text-[#004d44] mb-4 uppercase">1. Qu'est-ce qu'un cookie ?</h2>
                <p>Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, tablette ou mobile) lors de la visite d'un site internet. Il permet au site de mémoriser des informations sur votre visite.</p>
              </section>

              <section className="bg-gray-50 p-8 rounded-[3rem] border border-gray-100">
                <h2 className="text-xl font-black text-[#004d44] mb-4 uppercase">2. Cookies utilisés</h2>
                <ul className="list-disc pl-5 space-y-4">
                  <li><strong>Cookies techniques :</strong> Indispensables au fonctionnement du simulateur et à la navigation sécurisée.</li>
                  <li><strong>Cookies analytiques :</strong> Pour mesurer l'audience et améliorer l'ergonomie du site (type Google Analytics).</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-black text-[#004d44] mb-4 uppercase">3. Paramétrage</h2>
                <p>Vous pouvez vous opposer à l'enregistrement de cookies en configurant votre navigateur. Cependant, la désactivation des cookies techniques pourrait empêcher l'utilisation du simulateur PER.</p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Cookies;